export default [
	{
		name: 'Printables',
		pedigree_type: 'Printables'
	},
	{
		name: 'Panel',
		pedigree_type: 'Panel'
	}
]